'use client';

type Level = 'log' | 'info' | 'warn' | 'error' | 'debug';

export function logToServer(level: Level, message: string, data?: any, source?: string) {
  try {
    const payload = JSON.stringify({ level, message, data, source, ts: Date.now() });
    const url = '/api/log';
    if (typeof window !== 'undefined' && 'navigator' in window && 'sendBeacon' in navigator) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    // Swallow logging errors on client
  }
}

export const logger = {
  log: (message: string, data?: any, source?: string) => logToServer('log', message, data, source),
  info: (message: string, data?: any, source?: string) => logToServer('info', message, data, source),
  warn: (message: string, data?: any, source?: string) => logToServer('warn', message, data, source),
  error: (message: string, data?: any, source?: string) => logToServer('error', message, data, source),
  debug: (message: string, data?: any, source?: string) => logToServer('debug', message, data, source),
};

